// extracted by mini-css-extract-plugin
export default {"cls1":"FocusedNav-cls1___daf7487cb01bdc915a6","cls2":"FocusedNav-cls2__cf51bf80439fb3f2ebfd FocusedNav-cls1___daf7487cb01bdc915a6"};